'use strict';

/**
 * CodeMirror @ 提及功能插件
 * */
import CodeMirror from 'codemirror';
const Pos = CodeMirror.Pos;

CodeMirror.registerHelper('hint', 'anyword', function atMentionHint(editor, options) {
    return new Promise(resolve => {
        //
        if (typeof options.mention !== 'function') {
            return resolve();
        }

        const cur = editor.getCursor(),
            startPos = { line: cur.line, ch: 0 };
        let search = editor
            .getRange(startPos, cur, ' ')
            .split(' ')
            .slice(-1)[0];
        if (search[0] === '@') {
            search = search.slice(1);
        }

        Promise.resolve(options.mention(search)).then(results => {
            if (!Array.isArray(results)) {
                return resolve();
            }

            results = results.map(r => {
                if (typeof r === 'string') {
                    return r + ' ';
                }

                return {
                    text: r.text + ' ',
                    displayText: r.text,
                };
            });

            const rs = editor.getRange(startPos, cur),
                ls = editor.getLine(startPos.line),
                idx = ls.indexOf(' ', rs.length);

            // console.log('range: %s, line:%s, ch:%d, idx:%d', rs, ls, cur.ch, idx);

            resolve({
                list: results,
                from: Pos(cur.line, cur.ch - search.length),
                to: Pos(cur.line, Math.max(cur.ch, idx) + 1),
            });
        });
    });
});
